import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { CourseComponent } from './course/course.component';
import { ReportsIntegrationComponent } from './reports-integration/reports-integration.component';
import { AuthGuard } from './services/auth.guard';
import { UserManagementComponent } from './user-management/user-management.component';
import { LandingGuard } from './services/landing.guard';
import { DefaultComponent } from './default/default.component';
import { LwaziReportComponent } from './reports-integration/lwazi-report/lwazi-report.component';
import { MpiloReportComponent } from './reports-integration/mpilo-report/mpilo-report.component';
import { KitsoReportComponent } from './reports-integration/kitso-report/kitso-report.component';
import { KitsoaiReportComponent } from './reports-integration/kitsoai-report/kitsoai-report.component';
import { KitsoecdReportComponent } from './reports-integration/kitsoecd-report/kitsoecd-report.component';
import { KitsozaziReportComponent } from './reports-integration/kitsozazi-report/kitsozazi-report.component';
import { LesediReportComponent } from './reports-integration/lesedi-report/lesedi-report.component';
export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },

  { path: 'login', component: LoginComponent, data: { hideLayout: true } },

  { path: 'course', component: CourseComponent, canActivate: [AuthGuard], data: { breadcrumb: '/ Courses' } },
  //{path: 'default', component: DefaultComponent, data: {breadcrumb: '/ Default'}},
  {
    path: 'home', component: ReportsIntegrationComponent, data: { breadcrumb: '/ Reports' },
    children: [
      {
        path: 'report/:section',
        component: ReportsIntegrationComponent,
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'lwazi',
      //   component: LwaziReportComponent,
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: ' Lwazi' }
      // },
      // {
      //   path: 'lesedi',
      //   component: LesediReportComponent,
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: ' Lesedi' }
      // },
      // {
      //   path: 'mpilo',
      //   component: MpiloReportComponent,
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: ' Mpilo' }
      // },
      // {
      //   path: 'kitso',
      //   component: KitsoReportComponent,
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: ' Kitso DBE' }
      // },
      // {
      //   path: 'kitsoai',
      //   component: KitsoaiReportComponent,
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: ' Kitso AI' }
      // },
      // {
      //   path: 'kitsoecd',
      //   component: KitsoecdReportComponent,
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: ' Kitso ECD' }
      // },
      // {
      //   path: 'kitsozazi',
      //   component: KitsozaziReportComponent,
      //   canActivate: [AuthGuard],
      //   data: { breadcrumb: ' Kitso Zazi' }
      // }
    ]
  },



  {
    path: 'user-management', component: UserManagementComponent,
    canActivate: [AuthGuard],
    data: { breadcrumb: '/ User Management' }
  },
];
